import styled from "styled-components";
import { useState } from "react";
import UserProfileModal from "../modal/UserProfileModal";
import { useSelector } from "react-redux";
import { getWindowWidth } from "../../../features/basic/reducers/basicReducer";
import MobileMenu from "./MobileMenu";
import { PrimaryButton } from "../../../styles/basicComponents";
import { useLocation } from "react-router-dom";
import SmallerLogoIconComponent from "../iconComponents/SmallerIconComponent";
import { AccountIcon, MenuIcon } from "../modal/modalIcons";
import { useTheme, useVariables } from "../../../features/context/CustomerContext";
import useCustomTranslation from "../../../features/hooks/CustomUseTranslation";

const Title = styled.h1`
    @media screen and (max-width: 1500px) and (min-width: 1340px) {
        padding-left: 40px;
    }
    padding-left: 184px;
    padding-top: 10px;
`
const MobileTitle = styled.p`
    font-weight: 700;
    text-align: center;
    margin: 23px;
    line-height: 18px;
`
const HeaderDiv = styled.div`
    height: 100px;
    box-shadow: 0px 4px 12px 2px rgba(0, 0, 0, 0.25);
    background-color: white;
`
const HeaderContentDiv = styled.div`
    display:inline-flex;
`
const ButtonDiv = styled.div`
    margin-left: 29px;
    margin-right: 21px;
    margin-top: 10px;
`
const Button = styled(PrimaryButton)`
    width: 204px;
    height: 46px;
    box-shadow: none;
`

const Header: React.FC<{}> = () => {
    const { t } = useCustomTranslation();
    const location = useLocation();
    const variables = useVariables();
    
    const [showModal, setShowModal] = useState<boolean>(false);
    const [languageSelection, setLanguageSelection] = useState<boolean>(false);

    const windowWidth = useSelector(getWindowWidth);

    function handleProfileClick() {
        setLanguageSelection(false)
        setShowModal(!showModal)
    }

    const theme = useTheme();

    if(windowWidth < theme.mobileMenuBreakpoint) {
        return(
            <>
                <MobileTitle>{location.pathname ? t((location.pathname).replace("/", "")) : t("Manage authorizations")}</MobileTitle>
                <MenuIcon theme={theme} onClick={() => handleProfileClick()} />
                <MobileMenu show={showModal} showModal={setShowModal} languageSelection={languageSelection} setLanguageSelection={setLanguageSelection} />
            </>
        );
    }

    return (
        <HeaderDiv>
            <HeaderContentDiv>
                <SmallerLogoIconComponent/>
                <Title>{t("Manage authorizations")}</Title>
                {(windowWidth > 1263) && <ButtonDiv>
                    {variables.headerMenuLinks && variables.headerMenuLinks?.map((button, index) => (!button.hideInDesktop &&
                        <Button theme={theme} key={index} onClick={() => window.location.href = button.buttonLink}>{t(button.buttonTitle)}
                        </Button>))}
                </ButtonDiv>}
            </HeaderContentDiv>
            <AccountIcon theme={theme} onClick={() => handleProfileClick()} />
            <UserProfileModal show={showModal} languageSelection={languageSelection} setLanguageSelection={setLanguageSelection} />
        </HeaderDiv>)
}

export default Header